import React, { useEffect, useState } from 'react';
import { Grid, Snackbar, Alert } from '@mui/material';
import PageHeader from './common/PageHeader';
import SettingsIcon from '@mui/icons-material/Settings';
import BankConnectionCard from './Settings/BankConnectionCard';
import AccountSecurityCard from './Settings/AccountSecurityCard';
import PreferencesCard from './Settings/PreferencesCard';
import DataPrivacyCard from './Settings/DataPrivacyCard';

export default function SettingsPage() {
  // Single transient feedback channel shared by all settings cards
  const [snack, setSnack] = useState(null); // { message, severity }
  const notify = (message, severity = 'success') => setSnack({ message, severity });

  // Surface a success message when returning from the Akahu OAuth callback
  useEffect(() => {
    if (new URLSearchParams(window.location.search).get('akahu') === 'connected') {
      notify('Your bank has been connected via Akahu!');
    }
  }, []);

  return (
    <>
      <PageHeader
        title="Settings"
        icon={<SettingsIcon fontSize="large" />}
      />

      {/* Full-width layout matching the other pages: bank connection across the
          top, preferences and account side by side, data tools across the bottom */}
      <Grid container spacing={3} sx={{ pb: 4 }}>
        <Grid size={12}>
          <BankConnectionCard notify={notify} />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <PreferencesCard />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <AccountSecurityCard notify={notify} />
        </Grid>
        <Grid size={12}>
          <DataPrivacyCard notify={notify} />
        </Grid>
      </Grid>

      <Snackbar
        open={Boolean(snack)}
        autoHideDuration={4000}
        onClose={() => setSnack(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        {snack ? (
          <Alert severity={snack.severity} variant="filled" onClose={() => setSnack(null)} sx={{ width: '100%' }}>
            {snack.message}
          </Alert>
        ) : undefined}
      </Snackbar>
    </>
  );
}
